export default "/images/framework/Badge_12.3765e7f8.svg?3765e7f8";